<template>
  <v-snackbar
    :class="$style.snackbar"
    v-bind="$attrs"
    v-on="$listeners"
    :width="snackbar_width"
    :max-width="max_width"
    :timeout="timeout"
    :content-class="`${$style.snackbarText} text-body-1`"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { global_store } from '@/store';

@Component
export default class Snackbar extends Vue {
  @Prop({
    type: [
      String, Number,
    ],
    default: 'none',
  })
  max_width!: [string, number];

  @Prop({
    type: [
      String, Number,
    ],
    default: '-1',
  })
  timeout!: [string, number];

  get snackbar_width() {
    const win_width = window.innerWidth;
    const { state } = global_store;
    const width = state.is_mini_sidebar
      ? win_width - parseFloat(state.sidebar_mini_width)
      : win_width - parseFloat(state.sidebar_width);

    if (this.is_not_desktop) {
      return width + 500;
    }
    return width - 16;
  }

  get is_not_desktop() {
    return global_store.state.isTablet || global_store.state.isMobile;
  }
}
</script>

<style module lang="scss">
.snackbar {
  :global(.v-snack__wrapper) {
    margin-left: auto;
    margin-right: 0;
  }
}

.snackbarText {
  display: flex;
  align-items: center;
}
</style>
